<template>
  <div class="app-settings page-layout-padding">
    <h1 class="page-title margin-bottom-20" tabindex="0">
      {{ $getText('APP_SETTINGS_LABEL') }}
    </h1>
    {{ $getText('APP_SETTINGS_SUBLABEL') }}
    <h2 v-if="multipleDevices">
      {{ $getText('APP_EMPLOYEE') }}
    </h2>
    <template v-for="(device, index) in devicesEmployee">
      <div :key="index">
        <hr />
        <b-row>
          <b-col cols="9">
            <div v-if="device.description != null" class="description">
              {{ device.description }}
            </div>
            <div v-else class="description">
              {{ $getText('APP_UNKNOWN_DEVICE') }}
            </div>
            {{ $getText('APP_LAST_LOGIN') }}
            {{ formattedDeviceDate(device.lastActivity) }}
          </b-col>
        </b-row>
      </div>
    </template>
    <hr v-if="multipleDevices" />
    <h2 v-if="multipleDevices">
      {{ $getText('APP_PRIVATE') }}
    </h2>
    <template v-for="(device, index) in devicesPrivate">
      <div :key="index">
        <hr />
        <b-row>
          <b-col cols="9">
            <div v-if="device.description != null" class="description">
              {{ device.description }}
            </div>
            <div v-else class="description">
              {{ $getText('APP_UNKNOWN_DEVICE') }}
            </div>
            {{ $getText('APP_LAST_LOGIN') }}
            {{ formattedDeviceDate(device.lastActivity) }}
          </b-col>
        </b-row>
      </div>
    </template>
    <div v-if="devicesEmployee.length + devicesPrivate.length > 0">
      <hr />
      <br />
      <b-btn @click="$refs.cancelModal.show()">
        {{ $getText('APP_REMOVE_ALL') }}
      </b-btn>
    </div>
    <div v-if="devicesEmployee.length + devicesPrivate.length == 0">
      {{ $getText('APP_NO_DEVICES') }}
    </div>
    <aula-modal
      ref="cancelModal"
      ok-text="BUTTON_YES"
      @cancelClicked="$refs.cancelModal.hide()"
      @okClicked="unregisterAll()"
    >
      {{ $getText('APP_MODAL_CONFIRM_1') }}<br />
      {{ $getText('APP_MODAL_CONFIRM_2') }}
    </aula-modal>
  </div>
</template>

<script>
import { types } from '../../store/types/types';
import { mapGetters, mapActions } from 'vuex';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';

export default {
  data: function () {
    return {
      devicesEmployee: {},
      devicesPrivate: {},
    };
  },
  computed: {
    ...mapGetters({
      notificationSettings: types.GET_NOTIFICATION_SETTINGS,
      isMobile: types.GET_IS_MOBILE,
    }),
    multipleDevices() {
      return this.devicesPrivate.length > 0 && this.devicesEmployee.length > 0;
    },
  },
  methods: {
    ...mapActions({
      getNotificationSetting: types.SET_NOTIFICATION_SETTINGS,
      unregisterAllDevices: types.UNREGISTER_ALL,
    }),
    formattedDeviceDate(dateTime) {
      return DateTimeUtil.longDate(dateTime, true, true);
    },
    initAppSetting() {
      this.getNotificationSetting().then(() => {
        this.devicesPrivate = this.notificationSettings.deviceList.filter(item => item.appType == 'Private');
        this.devicesPrivate.sort(function (device1, device2) {
          const deviceName1 = device1.description === null ? '' : device1.description.toLowerCase();
          const deviceName2 = device2.description === null ? '' : device2.description.toLowerCase();
          return deviceName1 > deviceName2 ? 1 : -1;
        });
        this.devicesEmployee = this.notificationSettings.deviceList.filter(item => item.appType == 'Staff');
        this.devicesEmployee.sort(function (device1, device2) {
          const deviceName1 = device1.description === null ? '' : device1.description.toLowerCase();
          const deviceName2 = device2.description === null ? '' : device2.description.toLowerCase();
          return deviceName1 > deviceName2 ? 1 : -1;
        });
      });
    },
    unregisterAll() {
      this.$refs.cancelModal.hide();
      this.unregisterAllDevices().then(() => {
        this.initAppSetting();
      });
    },
  },
  mounted() {
    setTimeout(function () {
      document.querySelector('.app-settings .page-title').focus();
    }, 500);
  },
  created() {
    this.initAppSetting();
  },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.app-settings {
  max-width: 1024px;
  .description {
    font-size: 18px;
  }
  h2 {
    margin-top: 40px;
  }
  .remove {
    position: relative;
    top: 18px;
  }
}
</style>
